import * as types from './constants';

const initialState = {
  listData: {
    dataTable: [],
    loading: false,
    message: null,
    count: 0,
    next: null,
    previous: null,
    curr_page: 1,
    errors_api: {},
    queryParsed: false
  }
};

const actions = {
  // Get DataExports
  [types.GET_DATA_EXPORTS_REQUEST]: state => {
    const data = {
      ...state,
      listData: { ...state.listData, loading: true }
    };

    return { ...data };
  },

  [types.GET_DATA_EXPORTS_DONE]: (state, { payload }) => {
    const data = {
      ...state,
      listData: {
        ...state.listData,
        ...payload,
        loading: false
      }
    };

    return { ...data };
  },

  [types.GET_DATA_EXPORTS_FAILED]: (state, { payload }) => {
    const data = {
      ...state,
      listData: { ...state.listData, loading: false, errors_api: payload }
    };

    return { ...data };
  },

  // Operations
  [types.DATA_EXPORTS_SET_PAGE]: (state, { payload }) => {

    const data = {
      ...state,
      listData: { ...state.listData, curr_page: parseInt(payload) || 1, queryParsed: true }
    };

    return { ...data };
  }
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};